import React from 'react';
import clsx from 'clsx';

import { Path, useViewerPathsStatusQuery } from '@edx/graphql/generated';
import { Link } from '@edx/components/link';
import { IconPlaySolid } from '@edx/components/icons';

type Props = {
  paths: Path[];
};

export const PathsMenu: React.FC<Props> = ({ paths }) => {
  const { data } = useViewerPathsStatusQuery();

  return (
    <aside>
      <ul
        aria-label="Itinerarios"
        className="flex flex-col md:flex-row lg:flex-col items-center md:items-start lg:space-x-0 md:space-x-4 space-y-4 md:space-y-0 lg:space-y-4"
      >
        {paths.map(({ name, videosCount, images, resourcePath }: Path, index) => {
          const viewerCompletionPercentage = data?.paths?.[index]?.viewerProgressPercentage;

          return (
            <li key={resourcePath} className="max-w-md">
              <Link href={resourcePath}>
                <div>
                  <div className="relative group h-48">
                    {images.index.medium && (
                      <img className="h-full object-cover" loading="eager" src={images.index.medium} alt={name} />
                    )}
                    <div className="absolute inset-0 flex flex-col justify-between p-2 bg-gray-800 bg-opacity-50 group-hover:bg-opacity-0 transition duration-150">
                      <div className="flex">
                        <div className="p-2 bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-all duration-200 ease transform translate-y-3 group-hover:translate-y-0">
                          <IconPlaySolid className="text-primary-500 w-6" />
                        </div>
                      </div>
                    </div>

                    {viewerCompletionPercentage ? (
                      <span
                        className={clsx(
                          'z-10 absolute bottom-0 h-2px',
                          viewerCompletionPercentage === 100 ? 'bg-green' : 'bg-primary-500'
                        )}
                        style={{ width: `${viewerCompletionPercentage}%` }}
                        data-testid="completionPercentage"
                      />
                    ) : null}
                  </div>
                </div>

                <div className="flex flex-col font-body text-gray-500 p-2 space-y-2">
                  <header className="text-4xl md:text-3xl lg:text-4xl uppercase font-display text-gray-300 leading-tight">
                    {name}
                  </header>

                  <span className="text-xs uppercase tracking-widest font-medium leading-relaxed">
                    {videosCount} videos
                  </span>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};
